import axiosInstance from "@/services/axiosInterceptor";

export async function getAvailableGraceTime(id, date) {
  try {
    const response = await axiosInstance.get(`students/session/grace-times`);
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
export async function extendSessionDuration(roomId, durationInMinutes) {
  try {
    const response = await axiosInstance.post(`guides/extendSessionDuration`, {
      roomId,
      duration: durationInMinutes,
    });
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
